import API from "../utils/apiUtils";


// User
export const getUserDetails = () => API.get('user/me');
export const oauthLogout = () => API.post('oauth/logout');
export const putUser = ({ user_id, data }) => API.put('user/'+ user_id, data);
export const acceptTermsUpdate = () => API.post('user/terms/accept');
